import type {LinksListSliceDefaultPrimaryListItemsItem} from 'prismicio-types'
import {Icon} from 'src/common/Icon'
import {LinkWrapper} from 'src/common/LinkWrapper'

type LinksListProps = {
  item: LinksListSliceDefaultPrimaryListItemsItem
  pageUid?: string
  componentIndex?: number
  index: number
}

export const ListItem = ({item, pageUid, componentIndex, index}: LinksListProps) => (
  <LinkWrapper
    className="group/list-item"
    link={item.link}
    key={`link-item-${index}`}
    mktgId={`links-list-item-${index}`}
    location={`links-list-${componentIndex}`}
    dataType="links-list-item"
    pageName={pageUid}
  >
    <div className="w-full py-8 max-lg:grid max-lg:grid-cols-[1fr_32px] max-lg:grid-rows-[auto_auto] max-lg:gap-x-6 max-lg:gap-y-3 max-lg:[grid-template-areas:'title_icon''content_icon'] lg:flex lg:max-h-[84px] lg:items-center lg:justify-between lg:overflow-hidden">
      <div className="max-lg:[grid-area:title] lg:flex lg:w-full lg:max-w-[600px] lg:translate-x-[-29px] lg:transition-all lg:duration-200 lg:ease-in-out lg:group-hover/list-item:translate-x-0">
        <div className="mr-6 h-[5px] w-[5px] min-w-[5px] self-center rounded-[1px] bg-moss-grey-550 max-lg:hidden" />
        <p className="text-tg-body-l text-moss-black">{item.first_column}</p>
      </div>
      <div className="max-lg:flex max-lg:flex-col max-lg:gap-1 max-lg:[grid-area:content] lg:flex lg:w-full lg:justify-between">
        <div className="max-lg:flex max-lg:flex-col max-lg:gap-1 lg:flex lg:w-full lg:items-center lg:lg:justify-around lg:gap-1">
          <p className="text-button uppercase leading-[14px] text-moss-grey-400 lg:w-full lg:max-w-[200px]">
            {item.second_column}
          </p>
          <p className="text-button uppercase leading-[14px] text-moss-grey-400 lg:w-full lg:max-w-[120px]">
            {item.third_column}
          </p>
        </div>
        <div className="flex size-8 min-w-8 items-center justify-center rounded-[2px] bg-green-neon max-lg:hidden">
          <Icon name="arrow" className="size-2.5 -rotate-45 text-moss-black" />
        </div>
      </div>
      <div className="max-lg:flex max-lg:items-end max-lg:justify-end max-lg:[grid-area:icon] lg:hidden">
        <div className="flex size-8 min-w-8 items-center justify-center rounded-[2px] bg-green-neon">
          <Icon name="arrow" className="size-2.5 -rotate-45 text-moss-black" />
        </div>
      </div>
    </div>
  </LinkWrapper>
)
